import { Directive, Input } from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[appPasswordValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordValidatorDirective, multi: true }]
})
export class PasswordValidatorDirective implements Validator {
  @Input() password: string | undefined;

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null {
    return control.value !== this.password ? {error: 'invalid input'} : null;
  }
}
